import { call, put, takeLatest } from "redux-saga/effects";
import { loginApi } from "../../../api/auth/loginApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { ILoginStart, eLoginActions } from "../../action-types/auth/ILoginActions";
import { actions } from "../../actions";

export function* loginSaga(): any {
    yield takeLatest(eLoginActions.LOGIN_START, loginWorker)
}
function* loginWorker(action: ILoginStart): any {
    try {
        const res: IBaseRespone = yield call([loginApi, loginApi.login], action.payload)
        if (res.is_success) {
            yield put(actions.login.loginSuccess(res.data))
            yield put(actions.auth.getUserSuccss(res.data.profile))
        } else {
            yield put(actions.login.loginError(res.message))
        }
    } catch (error: any) {
        yield put(actions.login.loginError(error?.response?.data?.message ?? ""))
    }
}